"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActiveOrder = exports.identity = exports.noop = void 0;
var constants_1 = require("./constants");
var noop = function () { return undefined; };
exports.noop = noop;
var identity = function (v) { return v; };
exports.identity = identity;
var isActiveOrder = function (order) {
    return constants_1.activeOrderStatuses.indexOf(order.status) > -1;
};
exports.isActiveOrder = isActiveOrder;
